import { Voluntario } from '../../types/voluntarios/Voluntario';
import createApiModule from '../createApiModule';
import { showVoluntario as showVoluntarioApi } from '../../api/voluntarios/showVoluntario';
import { GenericState } from '../../types/apiModule';
import { t } from '../../i18n';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface showVoluntarioState extends GenericState<Voluntario | null> {}

const initialState: showVoluntarioState = {
  errors: null,
  loading: false,
  data: null,
};

const showVoluntarioModule = createApiModule({
  name: 'showVoluntario',
  apiMethod: showVoluntarioApi,
  initialState,
  parse: (voluntario) => voluntario as Voluntario | null,
  onSuccess: () => {},
  onError: () => ({
    message: t('StoreVoluntariosShowVoluntarioModuleErrorCargandoElVoluntario'),
  }),
  onValidationError: () => {},
});

export const {
  start: showVoluntario,
  success: showVoluntarioOk,
  error: showVoluntarioKo,
  refresh: showVoluntarioRefresh,
  reset: showVoluntarioReset,
} = showVoluntarioModule.slice.actions;

export const { sagas } = showVoluntarioModule;

export default showVoluntarioModule;
